import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DepotClientNetRequest } from '../models/DepotClientNetRequest';
import { BusinessDepotRequest } from '../models/businessDepotRequest';
import { RetraitClientNetRequest } from '../models/retraitClientNetRequest';
import { PartenaireBaccountInfo } from '../models/partenaire-baccount-info';
import { PartenaireEmployeeOperationSecurity } from '../models/partenaireEmployeeOperationSecurity';

@Injectable({ providedIn: 'root' })
export class PartnerService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private authHeaders() {
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token });
  }

  depotClientP(formdata: any, username: any) {
    return this.http.post(this.host + "/utilisateur/partenaire/depot/sur/compte/client/" + username, formdata, { headers: this.authHeaders() });
  }

  depotClientNetSurComptePrimaire(payload: DepotClientNetRequest) {
    console.log("================================================", payload);
    return this.http.post(this.host + "/utilisateur/partenaire/depot/sur/compte/primaire/client/net", payload, { headers: this.authHeaders() });
  }
  depotClientNetSurCompteBusiness(payload: BusinessDepotRequest) {
    console.log("================================================", payload);
    return this.http.post(this.host + "/utilisateur/partenaire/depot/sur/compte/bussness/client/net", payload, { headers: this.authHeaders() });
  }

  retraitClientNetSurComptePrimaire(req: RetraitClientNetRequest) {
    console.log("================================================", req);
    return this.http.post<number>(this.host + "/utilisateur/partenaire/retrait/sur/compte/primaire/client/net", req, { headers: this.authHeaders() }
    );
  }

  retraitClientNetSurCompteBusiness(req: RetraitClientNetRequest) {
    return this.http.post<number>(this.host + "/utilisateur/partenaire/retrait/sur/compte/bussness/client/net", req, { headers: this.authHeaders() }
    );
  }



  depotaffaireP(formdata: any, username: any) {
    return this.http.post(this.host + "/utilisateur/partenaire/depot/sur/compte/affaire/" + username, formdata, { headers: this.authHeaders() });
  }

  getPartenaireMensualite(username: any) {
    return this.http.get(this.host + "/utilisateur/partenaire/depot/affaire/mensualites/" + username, { headers: this.authHeaders() });
  }

  getPartenairebAccount(username: any) {
    return this.http.get<PartenaireBaccountInfo>(this.host + "/utilisateur/partenaire/businessgAccount/info/" + username, { headers: this.authHeaders() });
  }

  getEmployeeOperationSecurity(username: any) {
    return this.http.get<PartenaireEmployeeOperationSecurity>(
      this.host + "/utilisateur/partenaire/employee/operation/security/" + username,
      { headers: this.authHeaders() }
    );
  }

  getEmployeeStatus(username: any) {
    return this.http.get<{ username: string; matriculeEmploye: string; supervisor: boolean; activationRequired: boolean }>(
      this.host + "/utilisateur/partenaire/employee/status/" + username,
      { headers: this.authHeaders() }
    );
  }

  activateEmployeeFirstLogin(payload: { matriculeEmploye: string; password: string; confirmPassword: string; }) {
    return this.http.post<number>(
      this.host + "/utilisateur/partenaire/employee/activate/first-login",
      payload,
      { headers: this.authHeaders() }
    );
  }

  retraitClientPrimaire(formdata: any, username: any) {
    return this.http.post(this.host + "/utilisateur/partenaire/retrait/compte/primaire/client/" + username, formdata, { headers: this.authHeaders() });
  }

  retraitClientbussness(formdata: any, username: any) {
    return this.http.post(this.host + "/utilisateur/partenaire/retrait/compte/bussness/client/" + username, formdata, { headers: this.authHeaders() });
  }

  ajouterPartenairePartenaire(formdata: any, username: any) {
    return this.http.post(this.host + "/utilisateur/partenaire/ajouter/partenaire/" + username, formdata, { headers: this.authHeaders() });
  }
  updateNouveauPartenaire(username: any, partenaireid: any, formdata: any) {
    return this.http.put(this.host + "/utilisateur/partenaire/update/" + username + "/" + partenaireid, formdata, { headers: this.authHeaders() });
  }

  getCaissiersPartenaire(username: any) {
    return this.http.get(this.host + "/utilisateur/partenaire/afficher/caisiers/" + username, { headers: this.authHeaders() });
  }

  getAvailableEmployeeRoles(username: any) {
    return this.http.get<string[]>(
      this.host + "/utilisateur/partenaire/employee/available-roles/" + username,
      { headers: this.authHeaders() }
    );
  }

  getallPaiementTransaction() {
    return this.http.get(this.host + "/utilisateur/partenaire/paiement/transactions", { headers: this.authHeaders() });
  }


  getFacturesBaccount() {
    return this.http.get(this.host + "/utilisateur/partenaire/facturation/baccount/all", { headers: this.authHeaders() });
  }

  transfertMensualiteForce(id: any, baccountNumber: any) {
    return this.http.post(this.host + "/business/facturation/make/tranfert/" + id + "/" + baccountNumber, null, { headers: this.authHeaders() });
  }

  getMensualiteAndTaxesList(accountid: any) {
    return this.http.get(this.host + "/utilisateur/partenaire/baccount/mensualite/" + accountid, { headers: this.authHeaders() });
  }
}
